import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useThrottle } from "../../../../hooks/useThrottle"
import { setCurrentSearchUsername } from "../../../../store/messagingSlice"
import { FocusHandler } from "./FocusHandler"
import type {
    ThreadSearchViewModel,
    ThreadSearchViewModelPros,
} from "./ThreadSearchTypes"

export const GeneralViewModel = ({
    dispatch,
    typingThrottle,
    onTyping,
    focusCallback,
}: ThreadSearchViewModelPros): ThreadSearchViewModel => {
    const [filter, setFilter] = useSearchParams()
    const qParam = filter.get("q") ?? ""
    const [text, setText] = useState<string>(qParam)
    const throttledFilter = useThrottle(qParam, typingThrottle)

    useEffect(() => {
        if (text !== qParam) {
            setFilter({ q: text }, { replace: true })
        }
    }, [text, qParam, setFilter])

    useEffect(() => {
        onTyping && onTyping(throttledFilter)
        dispatch(setCurrentSearchUsername(throttledFilter || null))
    }, [throttledFilter, onTyping, dispatch])

    const fh = FocusHandler(dispatch, setText, focusCallback)
    return {
        text,
        setText,
        focused: fh.focused,
        handleFocus: fh.handleFocus,
    }
}
